import React from 'react';
import clsx from 'clsx';
import styles from './Textarea.module.scss';

interface Props {
  label: string;
  value: string;
  onChange: (e: React.ChangeEvent<HTMLTextAreaElement>) => void;
  onBlur?: (e: React.FocusEvent<HTMLTextAreaElement>) => void;
  name?: string;
  rows?: number;
  error?: string;
  className?: string;
}

export function Textarea({
  label,
  value,
  onChange,
  onBlur,
  name,
  rows = 2,
  error,
  className
}: Props) {
  const hasValue = value !== '';

  return (
    <div className={clsx(styles.field, className)}>
      <div className={clsx(styles.wrapper, { [styles.wrapperError]: !!error })}>
        <label className={clsx(styles.label, { [styles.labelUp]: hasValue })}>
          {label}
        </label>
        <textarea
          className={styles.textarea}
          name={name}
          value={value}
          onChange={onChange}
          onBlur={onBlur}
          rows={rows}
        />
      </div>
      {error && <span className={styles.error}>{error}</span>}
    </div>
  );
}
